import React from 'react';
import { Link } from 'react-router';

//This is the link to (or from) the admin site to be displayed in the header bar
export default class AdminLink extends React.Component {
  constructor (props){    
    super(props);
    this.state = {
    };
  }
  
  render() {
    let text = this.props.admin ? "User" : "Admin";
    let href = this.props.admin ? "dashboard" : "admin";
    return (<Link className="adminLink" to={href}>{text}</Link>);
  }
}



// WEBPACK FOOTER //
// ./src/components/AppLayout/AdminLink.js